import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';

export default function BreadcrumbsMenu() {
    const { t } = useTranslation();

    return (
        <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="https://www.conta.com.py/" target="_blank">
                {t('breadcrumbs.home')}
            </Link>
            <Link
                underline="hover"
                color="inherit"

                href="https://www.conta.com.py/post/impuesto-a-la-renta-personal-irp-conceptos-basicos">
                {t('breadcrumbs.calculator')}
            </Link>
            <Typography color="text.primary">{t('breadcrumbs.current')}</Typography>
        </Breadcrumbs>
    );
}
